var map = {
	"./images1/favicon-32x32.svg": "./src/assets/images1/favicon-32x32.svg",
	"./images2/favicon-32x32.svg": "./src/assets/images2/favicon-32x32.svg",
	"./images3/favicon-32x32.svg": "./src/assets/images3/favicon-32x32.svg",
	"./images4/favicon-32x32.svg": "./src/assets/images4/favicon-32x32.svg",
	"./images5/favicon-32x32.svg": "./src/assets/images5/favicon-32x32.svg",
	"./images52/favicon-32x32.svg": "./src/assets/images52/favicon-32x32.svg",
	"./images53/favicon-32x32.svg": "./src/assets/images53/favicon-32x32.svg",
	"./images55/favicon-32x32.svg": "./src/assets/images55/favicon-32x32.svg",
	"./images56/favicon-32x32.svg": "./src/assets/images56/favicon-32x32.svg",
	"./images57/favicon-32x32.svg": "./src/assets/images57/favicon-32x32.svg",
	"./images58/favicon-32x32.svg": "./src/assets/images58/favicon-32x32.svg",
	"./images6/favicon-32x32.svg": "./src/assets/images6/favicon-32x32.svg",
	"./images60/favicon-32x32.svg": "./src/assets/images60/favicon-32x32.svg",
	"./images7/favicon-32x32.svg": "./src/assets/images7/favicon-32x32.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/images.*\\/favicon\\-32x32\\.svg$";